document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector("#faq-search-input");
  const results = document.querySelector("#faq-search-results");
  const faqDataEl = document.querySelector("#faq-json");
  if (!input || !results || !faqDataEl) return;

  let faqs = [];
  try {
    faqs = JSON.parse(faqDataEl.textContent.trim());
  } catch (err) {
    console.error("Error al parsear JSON de FAQs:", err);
  }

  const richTextToPlain = node => {
    if (!node) return "";
    if (typeof node === "string") return node;
    if (Array.isArray(node)) return node.map(richTextToPlain).join("");
    if (node.type === "text" && typeof node.value === "string") return node.value;

    const childrenText = (node.children || []).map(richTextToPlain).join("");
    if (node.type === "paragraph" || node.type === "heading") {
      return `${childrenText}\n`;
    }

    return childrenText;
  };

  const normalizeContent = raw => {
    const baseText = typeof raw === "string" ? raw : "";
    const trimmed = baseText.trim();

    if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        return richTextToPlain(parsed).replace(/\n{2,}/g, "\n").trim();
      } catch (err) {
        console.warn("No se pudo parsear el richtext de FAQ:", err);
      }
    }

    return baseText;
  };

  faqs = faqs.map(faq => ({
    ...faq,
    normalizedContent: normalizeContent(faq.content)
  }));

  const escapeRegExp = str => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const getMatchingLine = (content, query) => {
    if (!query) return content;
    const lowerQuery = query.toLowerCase();
    const lines = content.split(/\r?\n/);
    const matchLine = lines.find(line => line.toLowerCase().includes(lowerQuery));
    return matchLine ?? lines[0] ?? "";
  };

  const highlightMatch = (text, query) => {
    if (!query) return text;
    const regex = new RegExp(escapeRegExp(query), "ig");
    return text.replace(regex, match => `<mark class="bg-dark text-light">${match}</mark>`);
  };

  const buildSnippet = (text, query, maxLength = 200) => {
    if (!text) return "";
    if (!query) return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const lower = text.toLowerCase();
    const idx = lower.indexOf(query);
    if (idx === -1) return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const padding = Math.max(0, Math.floor((maxLength - query.length) / 2));
    const start = Math.max(0, idx - padding);
    const end = Math.min(text.length, idx + query.length + padding);

    let snippet = text.slice(start, end);
    if (start > 0) snippet = `...${snippet}`;
    if (end < text.length) snippet = `${snippet}...`;
    return snippet;
  };

  let timer = null;

  input.addEventListener("input", () => {
    const q = input.value.trim().toLowerCase();
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      results.innerHTML = "";

      if (q.length < 2) {
        results.classList.add("hidden");
        return;
      }

      const filtered = faqs
        .map(faq => {
          const questionMatch = faq.question.toLowerCase().includes(q);
          const contentMatch = faq.normalizedContent.toLowerCase().includes(q);

          if (!questionMatch && !contentMatch) return null;

          const matchedLine = contentMatch
            ? getMatchingLine(faq.normalizedContent, q)
            : faq.normalizedContent;
          const snippet = buildSnippet(matchedLine, q);

          return {
            ...faq,
            highlightedContent: highlightMatch(snippet, q)
          };
        })
        .filter(Boolean);

      if (filtered.length) {
        results.classList.remove("hidden");
        results.innerHTML = `
          <div class="flex flex-col gap-4">
            <h2 class="px-5 text-sm font-semibold uppercase lg:px-0">
              ${filtered.length} resultados para "${q}"
            </h2>
            <ul class="faq-results-list">
              ${filtered.map(f =>
                `<li class="faq-result-item not-last:border-b-2 border-neutral-200">
                  <a href="${f.url}" class="block font-semibold py-2 hover:underline">${f.question}</a>
                  <span class="text-neutral-500" style="display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;">${f.highlightedContent}</span>
                </li>`
              ).join("")}
            </ul>
          </div>
        `;
      } else {
        results.classList.remove("hidden");
        results.innerHTML = `<p class="text-neutral-400">No se encontraron resultados para "${q}".</p>`;
      }
    }, 250);
  });
});
